import { HttpTimeoutError } from '../types/http-timeout-error';
import { isResponseErrorTransient } from './is-response-error-transient';
export const withRetry = async (fn, maxAttempts) => {
    try {
        const response = await fn();
        if (!response.ok && isResponseErrorTransient(response) && maxAttempts > 1) {
            return withRetry(fn, maxAttempts - 1);
        }
        return response;
    }
    catch (e) {
        if (e instanceof HttpTimeoutError && maxAttempts > 1) {
            return withRetry(fn, maxAttempts - 1);
        }
        throw e;
    }
};
//# sourceMappingURL=with-retry.js.map